import { combineReducers } from 'redux'
import {
  ANIMAL_PAGE_ERROR, ANIMAL_PAGE_LOADING, ANIMAL_LIST_SUCCESS,
  ANIMAL_VIEW_SUCCESS, ANIMAL_PAGE_SUCCESS, ANIMAL_VIEW_ERROR,
  ANIMAL_ADD_ERROR, ANIMAL_ADD_LOADING, ANIMAL_ADD_SUCCESS,
  ANIMAL_VIEW_LOADING, ANIMAL_DELETE_ERROR, ANIMAL_DELETE_LOADING, 
  ANIMAL_DELETE_SUCCESS, ANIMAL_UPDATE_SUCCESS, ANIMAL_UPDATE_ERROR, ANIMAL_UPDATE_LOADING, ANIMAL_LIST_ERROR, ANIMAL_LIST_LOADING
} from './constant'

const animalPageError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_PAGE_ERROR:
      return action.animalPageError
    default:
      return state
  }
}

const animalPageLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_PAGE_LOADING:
      return action.animalPageLoading
    default:
      return state
  }
}

const animalPageSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_PAGE_SUCCESS:
      return action.animalPageSuccess
    default:
      return state
  }
}

const animals = (state = [], action) => {
  switch (action.type) {
    case ANIMAL_PAGE_SUCCESS:
      return action.animal
    case ANIMAL_LIST_SUCCESS:
      return action.animal
    default:
      return state
  }
}

const animal = (state = [], action) => {
  switch (action.type) {
    case ANIMAL_VIEW_SUCCESS:
      return action.animal
    default:
      return state
  }
}

const animalAddError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_ADD_ERROR:
      return action.animalAddError
    default:
      return state
  }
}

const animalAddLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_ADD_LOADING:
      return action.animalAddLoading
    default:
      return state
  }
}

const animalAddSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_ADD_SUCCESS:
      return action.animalAddSuccess
    default:
      return state
  }
}

const animalViewError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_VIEW_ERROR:
      return action.animalViewError
    default:
      return state
  }
}

const animalViewLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_VIEW_LOADING:
      return action.animalViewLoading
    default:
      return state
  }
}

const animalViewSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_VIEW_SUCCESS:
      return action.animalViewSuccess
    default:
      return state
  }
}

const animalDeleteError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_DELETE_ERROR:
      return action.animalDeleteError
    default:
      return state
  }
}

const animalDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_DELETE_LOADING:
      return action.animalDeleteLoading
    default:
      return state
  }
}

const animalDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_DELETE_SUCCESS:
      return action.animalDeleteSuccess
    default:
      return state
  }
}

const animalUpdateError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_UPDATE_ERROR:
      return action.animalUpdateError
    default:
      return state
  }
}

const animalUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_UPDATE_LOADING:
      return action.animalUpdateLoading
    default:
      return state
  }
}

const animalUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_UPDATE_SUCCESS:
      return action.animalUpdateSuccess
    default:
      return state
  }
}

const animalListError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_LIST_ERROR:
      return action.animalListError
    default:
      return state
  }
}

const animalListLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_LIST_LOADING:
      return action.animalListLoading
    default:
      return state
  }
}

const animalListSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_LIST_SUCCESS:
      return action.animalListSuccess
    default:
      return state
  }
}

const animalReducer = combineReducers({
  animalPageError,
  animalPageLoading,
  animalPageSuccess,

  animals,
  animal,

  animalAddError,
  animalAddLoading,
  animalAddSuccess,

  animalViewError,
  animalViewLoading,
  animalViewSuccess,

  animalDeleteError,
  animalDeleteLoading,
  animalDeleteSuccess,

  animalUpdateError,
  animalUpdateLoading,
  animalUpdateSuccess,

  animalListError,
  animalListLoading,
  animalListSuccess,
})

export default animalReducer
